import { PlusInSquareIcon } from "assets/icons";
import { If } from "components";
import { useBoolean } from "hooks";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button, FormField } from "ui";

import { ProductBothTogetherMethod } from "../../../../../constants";
import {
  ProductsSelector,
  ProductsSelectorTable
} from "../../../../../widgets";
import { ProductFormValues } from "../../ProductDetailsForm.types";
import { VariantBlockPartProps } from "./VariantBlock.types";

import styles from "../../ProductDetailsForm.module.scss";

export const VariantBoughtTogetherBlock = ({
  variantIndex
}: VariantBlockPartProps) => {
  const {
    value: isSelectProductsModalOpen,
    setTrue: openSelectProductsModal,
    setFalse: closeSelectProductsModal
  } = useBoolean(false);

  const { t } = useTranslation();

  const { watch, setValue } = useFormContext<ProductFormValues>();
  const productBothTogetherMethod = watch("productBothTogetherMethod");
  const variantsBoughtTogetherProducts = watch(
    `variants.${variantIndex}.variantsBoughtTogether`
  );
  const productVariants = watch("variants");

  return productBothTogetherMethod ===
    ProductBothTogetherMethod.PRODUCTS_FOR_EACH_VARIANT ? (
    <FormField label={"Products frequently bought together with this variant"}>
      <div className={styles.productForm__block}>
        <If condition={variantsBoughtTogetherProducts.length > 0}>
          <ProductsSelectorTable
            products={variantsBoughtTogetherProducts}
            onChange={(value) => {
              setValue(
                `variants.${variantIndex}.variantsBoughtTogether`,
                value
              );
            }}
            value={variantsBoughtTogetherProducts}
            isLoading={false}
          />
        </If>
        <ProductsSelector
          isOpen={isSelectProductsModalOpen}
          onClose={closeSelectProductsModal}
          maxValueLength={2}
          value={variantsBoughtTogetherProducts}
          onChange={(value) => {
            setValue(`variants.${variantIndex}.variantsBoughtTogether`, value);
          }}
          excludeVariantIds={
            productVariants
              .map((variant) => variant.id)
              .filter(Boolean) as string[]
          }
        />

        <If condition={variantsBoughtTogetherProducts.length < 2}>
          <Button
            type="button"
            icon={<PlusInSquareIcon />}
            variant="default"
            onClick={openSelectProductsModal}
          >
            {t("Add products")}
          </Button>
        </If>
      </div>
    </FormField>
  ) : null;
};
